import React from 'react';
import './ContactRedesign.css';

const ContactContent = ({ history, fields, contactSubmit, handleChange, submitted }) => (
  <div className="contact-redesign">
    <section className="contact-hero">
      <div className="contact-wrap">
        <p className="contact-eyebrow">CONTACT</p>
        <h1>EditPage Contact</h1>
        <p className="contact-subtitle">
          Send us a message and we will get back to you as soon as we can.
        </p>
        <button
          className="contact-start-btn"
          type="button"
          onClick={() => {
            history.push('/signup');
          }}
        >
          Start Building
        </button>
      </div>
    </section>

    <section className="contact-form-shell">
      <div className="contact-wrap">
        <div className="contact-card">
          {submitted ? (
            <div className="contact-success">
              <h2>Thanks. We will get back to you as soon as we can.</h2>
              <p>Your message has been sent successfully.</p>
            </div>
          ) : (
            <form noValidate autoComplete="off" onSubmit={contactSubmit}>
              <div className="contact-grid-two">
                <div className="contact-field">
                  <label htmlFor="contact-first-name">First Name</label>
                  <input
                    id="contact-first-name"
                    type="text"
                    placeholder="First Name"
                    value={fields['firstName'] || ''}
                    onChange={(e) => {
                      handleChange('firstName', e);
                    }}
                  />
                </div>
                <div className="contact-field">
                  <label htmlFor="contact-last-name">Last Name</label>
                  <input
                    id="contact-last-name"
                    type="text"
                    placeholder="Last Name"
                    value={fields['lastName'] || ''}
                    onChange={(e) => {
                      handleChange('lastName', e);
                    }}
                  />
                </div>
              </div>

              <div className="contact-field">
                <label htmlFor="contact-email">Email</label>
                <input
                  id="contact-email"
                  type="email"
                  placeholder="Your email"
                  value={fields['email'] || ''}
                  onChange={(e) => {
                    handleChange('email', e);
                  }}
                />
              </div>

              <div className="contact-field">
                <label htmlFor="contact-message">Message</label>
                <textarea
                  id="contact-message"
                  rows="7"
                  placeholder="Your message"
                  value={fields['messageBody'] || ''}
                  onChange={(e) => {
                    handleChange('messageBody', e);
                  }}
                />
              </div>

              <button className="contact-send-btn" type="submit">
                Send Message
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  </div>
);

export default ContactContent;
